import TourPage from "@/components/TourPage";

export default function MaasaiMara3Day() {
  return (
    <TourPage
      tourId="kenya/maasai-mara-3-day"
      title="3 Days Maasai Mara National Reserve Safari"
      duration="3 Days / 2 Nights"
      price="Contact for price"
      image="/images/masai-mara-migration.jpg"
      description="Relish a 3-day safari adventure in Maasai Mara National Reserve, one of Kenya's most famous game reserves. Witness the incredible wildlife diversity, including lions, cheetahs, elephants, and wildebeests."
      itinerary={[
        {
          day: 1,
          title: "Nairobi / Maasai Mara Game Reserve",
          description: "Begin your Maasai Mara adventure.",
          activities: [
            "Arrive at Jomo Kenyatta International Airport and transfer to a city hotel for breakfast",
            "Proceed to Wilson Airport for a 45-minute domestic flight to Maasai Mara Game Reserve",
            "Met by representatives and transferred to a lodge or camp, with game viewing en route",
            "Lunch at the lodge, followed by a short siesta and an afternoon game drive"
          ],
          accommodation: "Lodge or Camp in Maasai Mara",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Maasai Mara Game Reserve",
          description: "Full day exploring the Maasai Mara.",
          activities: [
            "Full day in the reserve with morning and afternoon game drives",
            "Alternatively, enjoy a full-day game drive with a picnic lunch by the Mara River",
            "Spot a wide variety of wildlife, including elephants, rhinos, lions, and cheetahs"
          ],
          accommodation: "Lodge or Camp in Maasai Mara",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Maasai Mara / Nairobi",
          description: "Final day and return to Nairobi.",
          activities: [
            "Breakfast followed by transfer to the airstrip for a flight back to Nairobi",
            "Met at Wilson Airport and transfer to the Carnivore Restaurant for lunch",
            "Drop off at the airport for an international flight"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "All park entrance fees and permits",
        "All meals (breakfasts, lunches, and dinners)",
        "A professional driver guide",
        "All concession fees",
        "All transportation and airport transfers (4x4 luxury vehicle)",
        "All activities (unless labeled as optional)"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Tip",
        "The government imposed an increase in taxes and/or park fees",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "Coffee, soft drinks, snacks, and drinking water (on all days)"
      ]}
    />
  );
}
